import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {L3Model} from '../../../../models/L3Model';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-sl5-filter',
  templateUrl: './sl5-filter.component.html',
  styleUrls: ['./sl5-filter.component.scss']
})
export class Sl5FilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listFilterL3: any[];

  @Input() l3Data: any;
  @Input() l3Selected: L3Model;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('l3Data' in changes) {
      this.listFilterL3 = this.l3Data ? this.l3Data : [];
      this.optionSelected = null;
    }
    if (this.l3Selected) {
      this.optionSelected = this.l3Selected;
    }
  }
  ngOnDestroy(): void {
  }
}
